import React, { Component } from 'react';
import {connect} from 'react-redux';
import{ Divider, Label, Dropdown, Button,Transition,Input,Accordion, Icon,Checkbox} from 'semantic-ui-react';

import {bindActionCreators} from 'redux';
import * as tokenActions from '../actions/actions';
import Chart from './chart'
import Graph from './graph';
import firebase from '../firebase';
import { toast } from 'react-toastify';



var moment = require('moment');
require('moment-timezone');

/*
    This is the main dashboard component.
    * Renders (or calls copmenets to render) graph,table, maps.
    * Allows for filtering data by Forest, Timeframe, and custom dates.
    * Allows for the download of requested data. 
    * Users can toggle the real-time listener to update the graphs and table in teal-time as the data is being produced by the network. 
    * Users can toggle the map.
    * Default data time-frame is set to three days. 
    * Data for graph and table are capped at 6000 records to stop the browser from attempting to render more data than the client machine can handle. 
*/

class Dashboard extends Component {
    constructor(props) {
        super(props);
        var newDate = new Date();
        this.state = {
            resp: 'Click to send request',
            nodeVisible:false,
            mapVisible:false,
            nodes:[],
            nodeDropdown:[],
            nodeInfo:null,
            nodeData:[],
            dataCount:null,
            meta:null,
            node_meta:null,
            isLoading:false,
            graphData:[],
            graphOptions:{},
            filterHidden:true,
            days:3,
            timeframe:1,
            selectedNode:null,
            selectedLimit:1000,
            activeIndex:1,
            rtlLive:false,
            selectedFromDate : 0,
            toDateTime : newDate,  
            dayMap : {
                "90 minutes": 0.0625,
                "3 hours": 0.125, 
                "12 hours": 0.5,
                "1 day":1,
                "3 days":3,
                "1 week": 7,
                "2 weeks":14,
                "1 month":30,
                "3 months":92,
                "6 months": 183,
                "1 year":356
            }

        }
        this.generateNodes = this.generateNodes.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.listenForChanghes = this.listenForChanghes.bind(this);
        this.onTimeChange = this.onTimeChange.bind(this);
        this.average = this.average.bind(this);
        this.getMin = this.getMin.bind(this);
        this.getMax = this.getMax.bind(this);
        this.range = this.range.bind(this);

        
    } 
    
    toggleVisibility = () => this.setState({ mapVisible: !this.state.mapVisible }, () =>{
        if(this.state.mapVisible === true) document.getElementById('mapDiv').scrollIntoView();;
        
        
    })

    handleMenuCollapse = (e, titleProps) => {
      const { index } = titleProps
      const { activeIndex } = this.state
      const newIndex = activeIndex === index ? -1 : index
  
      this.setState({ activeIndex: newIndex })
    }
    
    handleChange(e,data){
        let id = data.id;
        let value = data.value;
        var canberraTime = moment();
        if(id === "node_id_field"){
            this.setState({selectedNode:value})

        } else if(id === "node_days_field"){
            this.setState({timeframe:value})
        
        } else if(id === "node_start_date"){
            
            let from = moment(value).unix() || canberraTime.unix() - (86400 * 3);
            let newDays  = parseInt((this.state.selectedToDate - from) /60/60/24, 10);
            if(newDays < 1){
                newDays = 1;
            }
            if(newDays < 0){
                newDays = 0;
            }
            this.setState({selectedFromDate:from, timeframe:newDays})

        } else if(id === "node_end_date"){
            let to = moment(value).unix() || canberraTime.unix();
            let newDays  = parseInt((to - this.state.selectedFromDate) /60/60/24, 10);
            if(newDays < 1){
                newDays = 1;
            }
            if(newDays < 0){
                newDays = 0;
            }
            this.setState({selectedToDate:to, timeframe:newDays})

        } else if(id === "rtl"){
            this.setState({rtlLive:!this.state.rtlLive},() =>{
                this.listenForChanghes(this.state.rtlLive)
            })
        }
        
    }


    handleSubmit(e){
        e.preventDefault();
        if(!document.getElementById('node_end_date').value){
            let newTodate = moment().unix() ;
            
            if(newTodate){
                if(!document.getElementById('node_start_date').value){
                    let newFromDate = newTodate - parseInt(86400*this.state.timeframe, 10);
                    this.setState({selectedToDate:newTodate, selectedFromDate:newFromDate}, () =>{
                        this.props.tokenActions.getNodeData(this.state.selectedNode, this.state.timeframe, this.state.selectedFromDate, this.state.selectedToDate);
                    })

                } else{
                    this.setState({selectedToDate:newTodate}, () =>{
                        this.props.tokenActions.getNodeData(this.state.selectedNode, this.state.timeframe, this.state.selectedFromDate, this.state.selectedToDate);
                    })
                }
            }
        } else{
            this.props.tokenActions.getNodeData(this.state.selectedNode, this.state.timeframe, this.state.selectedFromDate, this.state.selectedToDate);
        }
    
    }

    componentWillMount(){
        const days = [
            {key:'90', value:0.0625, text:"90 minutes"},
            {key:'3 hours', value:0.125, text:"3 hours"},
            {key:'12 hours', value:0.5, text:"12 hours"},
            {key:'1 day', value:1, text:"1 day"},
            {key:'3 days', value:3, text:"3 days"},
            {key:'week', value:7, text:"1 week"},
            {key:'fortnight', value:14, text:"2 weeks"},
            {key:'month', value:30, text:"1 month"},
            {key:'quarter', value:92, text:"3 months"},
            {key:'semi', value:183, text:"6 months"},
            {key:'year', value:366, text:"1 year"},

        ]
        if(days.length > 0){
            this.setState({days:days})
        }

        
    }
    
    componentDidMount(){      
        this.props.tokenActions.getNodeInfo();
        
        var sleepRef = firebase.db.ref('sleep_controls/sleep_time');
        sleepRef.on('value', (snapshot) => {
                    let value = null;
                    if(snapshot.val() < 61){
                        value = snapshot.val() + " min"
                    } else{
                        value = parseFloat(snapshot.val()/60, 10).toFixed(2) + " hr"
                    }
                    if(value!==null){
                        this.setState({currentSleepTime:value})
                    }

        });
    }
  

    //turn on the real-time listener for National Arboretum Canberra in cloud firestore database
    listenForChanghes(value){
        // if value is false, we call the variable;
        // according to firestore, calling the assigned variable detaches the real-time listener   
        if(value === false){
            toast.warn('Real-time stream ended');
            this.unsubscribe();
            return;
        }
        
         this.unsubscribe =  firebase.fireStore.collection("National Arboretum Canberra")
        .onSnapshot(function(doc)  {
                var canberraTime = moment();
                var audio = new Audio('notification.mp3');

                //check if the update is the currently selected node on the graph. if so update graph and notify. 
                if(this.state.selectedNode && doc.docChanges.length === 1){
                    let nodeIndex = doc.docChanges[0].oldIndex;
                    if(nodeIndex > -1){
                        let newNode = this.state.nodeDropdown[nodeIndex].value;
                        if(value === true){
                            if(this.state.selectedNode === newNode){
                                toast('New update for ' + this.state.selectedNode);
                                audio.play();
                                this.state.selectedNode && this.state.selectedFromDate &&
                                this.props.tokenActions.getNodeData(this.state.selectedNode, this.state.timeframe, this.state.selectedFromDate, canberraTime.unix());
        
                            }
                        }
                    }
                }

                //notify when the firebase listenenr is turned on.
                if(doc.docChanges.length > 1){
                    toast.info('Streaming real-time');
                }

        }.bind(this));






    }

    average(key, rootkey){
        if(rootkey && rootkey!== undefined){
            let sum = 0;
            this.state.nodeData[rootkey] && this.state.nodeData[rootkey].forEach(sample =>{
                if(!isNaN(parseFloat(sample[key]))){
                    sum = sum + parseFloat(sample[key])
                }
            })
            return (sum/(this.state.nodeData[rootkey] && this.state.nodeData[rootkey].length)).toFixed(2)
        }

    }

    range(key,rootkey){
        let range  = this.getMax(key, rootkey) - this.getMin(key, rootkey);
        return range.toFixed(2);
    }
    getMin(key, rootkey){
        if(rootkey&& rootkey!== undefined){
            let arr = [];
            this.state.nodeData[rootkey] && this.state.nodeData[rootkey].forEach(sample =>{
                if(!isNaN(parseFloat(sample[key]))){
                    arr.push(parseFloat(sample[key]))
                }
                
            })
            return Math.min.apply(Math, arr);  
        }
   
    }

    getMax(key, rootkey){
        if(rootkey&& rootkey!== undefined){
            let arr = [];
            this.state.nodeData[rootkey] && this.state.nodeData[rootkey].forEach(sample =>{
                if(!isNaN(parseFloat(sample[key]))){
                    arr.push(parseFloat(sample[key]))
                }
            })
            return Math.max.apply(Math, arr);  
        }


    }

    onTimeChange(e){
        e.preventDefault();
        var field = e.target.id;
        if(field === 'node_start_date'){
            document.getElementById('node_days_field').firstChild.firstChild.data = null;
        } else{
            // this.setState = document.getElementById('node_days_field').firstChild.firstChild.data;
           document.getElementById('node_start_date').value = null;
        }

    }

    componentWillReceiveProps(props){
        if(props.getNodeDataSuccessAlert === true){
            this.setState({isLoading:false})
             this.setState({nodeData:props.nodeData.data, dataCount:props.nodeData.count, meta:props.nodeData.meta},()=>{
            })
            if(props.nodeData.length < 1){
                toast.warn("No data found for this node");
            }
            // }else{
            //     // toast("Node Data recieved Successfuly");
            // }
        }
        if(props.getNodeDataFailureAlert === true){
            toast.error("Could not retrive node data!");
            this.setState({isLoading:false})
        }
        // recieves metadata from all nodes during initial load to populate the map.
        if(props.nodeInfoSuccess === true && props.nodeInfoData){
            var list=[];
            var canberraTime = moment();
            this.setState({nodeInfo:props.nodeInfoData}, () =>{
                let temp = this.state.nodeInfo;
                let tempForests = [];

                Object.keys(temp).forEach(key =>{                  
                    let value = "F"+temp[key].forest_num+"  "+temp[key].forest_name
                    if(tempForests.indexOf(temp[key].forest_num) < 0){
                        list.push({key:value, value:value, text:value})
                        tempForests.push(temp[key].forest_num);
                        this.setState({nodeDropdown:list}, () =>{
                        })
                    }
                })
                if(list.length > 0){
                    this.setState({selectedNode:list[2].key, timeframe:3, selectedFromDate:canberraTime.unix()-(86400 * 3), selectedToDate: canberraTime.unix() },() =>{
                        this.props.tokenActions.getNodeData(this.state.selectedNode, this.state.timeframe, this.state.selectedFromDate, this.state.selectedToDate);
                    })
                }
    
            })
            this.setState({node_meta:props.nodeInfoData})




        }

        this.props.tokenActions.hideAlerts();


        
    }
    componentWillUnmount(){
        if(this.state.rtlLive === true){
            this.listenForChanghes(false)
        }
        
    }

    handleClick = (e) => {
        this.setState({nodeVisible:!this.state.nodeVisible })
       
      }
    generateNodes(nodeArray){
        return null;
    }
    
    

    generateNodeData(data, count, meta, node_meta){
        var generatedData = [];
        let datLength  = (Object.keys(data).length)
        if(data && datLength > 0){
            generatedData.push(
                <div className = 'column' style={{overflowY:'scroll', maxHeight:'100%'}}>
                    <Graph isFetching = {this.props.isFetching} meta={meta} range = {this.range}count = {count} data = {data} average = {this.average} getMin = {this.getMin} getMax = {this.getMax}/>
                </div>
            ); 
        }
        else{
            if (this.state.isLoading === false){
                generatedData.push(<Graph isFetching = {this.props.isFetching} data = {[{nodata:'nodata'}]}/>);
            }
            else{
                generatedData.push(<Graph/>);   
            }
           
        }
        
        return generatedData;
    }



    render(){
        const { nodeVisible, mapVisible, activeIndex } = this.state;
        const fieldStyle = {
           margin:'0px'
        }

    
        return(

            <div className ='center'>                        
                                <div className = 'ui stackable two column grid' style={fieldStyle}>

                                    <div className = 'column'>
                                        <Label  color='orange'   attached = 'top left'>
                                            Forest
                                        </Label>
                                        <Dropdown style={{width :'100%'}} placeholder='Forest'  id ='node_id_field'  onChange={this.handleChange} search selection options={this.state && this.state.nodeDropdown}/>
                                    </div>

                                    <div className = 'column'>
                                        <Label  color='orange'   attached = 'top left'>
                                            Timeframe
                                        </Label>
                                        <Dropdown  placeholder = '3 days' disabled = {false} style={{width :'100%'}} onChange={this.handleChange} id ='node_days_field' title = 'node_days_field'  selection options={this.state && this.state.days}/>
                                    </div>
                                </div>

                                <Accordion>
                                    <Accordion.Title active={activeIndex === 0} index={0} onClick={this.handleMenuCollapse}>
                                        <Icon name='dropdown' />
                                        More Options
                                    </Accordion.Title>
                                    <Accordion.Content active={activeIndex === 0}>
                                        <div className = 'ui stackable two column grid' style={fieldStyle}>
                                            <div className = 'column'>
                                                <Label  color='orange'   attached = 'top left'>
                                                    Start
                                                </Label>
                                                <Input style={{width :'100%'}} placeholder='start date' onChange = {this.handleChange} type="date" step='1'name="bday" id = "node_start_date"/>
                                            </div>

                                            <div className = 'column'> 
                                                <Label  color='orange'  attached = 'top left'>
                                                    End
                                                </Label>
                                                <Input style={{width :'100%'}} placeholder='end date' onChange = {this.handleChange} type="date" step='1'  id="node_end_date"/>
                                            </div>

                                            {/* <div className = 'column'>
                                                <Label  color='orange'  attached = 'top left'>
                                                    Limit
                                                </Label>
                                                <Input  style={{width :'100%'}} id ='node_limit_field'  defaultValue = {'N/A'} type = 'number' placeholder='e.g. 35'  min="1" max="1000"></Input>
                                            </div> */}

                                        </div>
                                    </Accordion.Content>
                                </Accordion>
                            {/* </Transition> */}
                            <div  >
                                <Button onClick ={this.handleSubmit}  primary content = {'Go'}/>
                                <Button content={mapVisible ? 'Hide Map' : 'Show Map'} onClick={this.toggleVisibility} />
                                <Checkbox style={{marginLeft:'90%' }} slider label='Real-Time' id = "rtl" onChange={this.handleChange} checked={this.state.rtlLive} />
                                
                                {this.state.currentSleepTime && 
                                    this.state.rtlLive ? 
                                        <Label style={{ marginLeft:'95%'}} color="teal" size={'mini'}>
                                            {this.state.currentSleepTime}
                                        </Label>
                                            :
                                        <Label style={{ marginLeft:'95%'}} color="" size={'mini'}>
                                            {this.state.currentSleepTime}
                                        </Label>                                
                                }

                            </div>
                            
                            
                            <Divider/>

                
                    <div id="dashWrapper">
                    {(nodeVisible) ? (
                        <div  className= "column" style={{marginBottom:"7px"}}>
                           <Divider/>

                        </div>

                            ):(null)}        
                        
                            <div className= 'ui stackable one column grid' style={{textAlign:"center", margin:"2px"}}>
                                {/* { (this.props.authenticated ) &&  */}
                                   { this.generateNodeData(this.state.nodeData, this.state.dataCount, this.state.meta, this.state.node_meta)   }
                                {/* }    */}
                                
                            </div> 
                            
                            <Transition visible={mapVisible} animation='scale' duration={2000}>
                                <div id = 'mapDiv'className = 'ui stackable one column grid'>
                                    <Chart chartTitle = "Map" count={this.state.dataCount} nodeInfo = {this.state.node_meta} average = {this.average}/>
                                </div>
                            </Transition>
                            


                        
                    </div>                
                
            </div>

        )
    }

}
function mapStateToProps(state) {
    return {
        ...state.initState
    };
}
function mapDispatchToProps(dispatch) {
    return {
        tokenActions: bindActionCreators(tokenActions, dispatch)
    };
}


export default connect(
    mapStateToProps,
    mapDispatchToProps
    
)(Dashboard);


// WEBPACK FOOTER //
// ./src/components/dashboard.js